import { ContestId, SolvedChallenge } from "../models/Types";

export default {
  initialise: async (
    baseUrl: string,
    challengeType: string,
    parentURL: string,
    contestId: ContestId,
    displayedLang: string,
    supportedLangs: string,
    purpose: string,
    hvToken: string,
  ) => {
    const params = new URLSearchParams({
      challengeType,
      parentURL,
      displayedLang,
      supportedLangs,
      purpose,
      ...(contestId ? { contestId } : {}),
      token: hvToken,
    });
    const url = `${baseUrl}/init?${params}`;
    const response = await fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });
    const data = await response.json();
    return data;
  },

  validate: async (
    baseUrl: string,
    token: string,
    solvedChallenge: SolvedChallenge,
    contestId: ContestId,
    purpose: string,
  ) => {
    const params = new URLSearchParams({
      token,
      contestId,
      purpose,
    });
    const url = `${baseUrl}/validate?${params}`;
    const response = await fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      headers: {
        pcaptcha: JSON.stringify(solvedChallenge),
      },
      credentials: "include",
    });
    const verifyData = await response;
    return verifyData;
  },

  finalize: async (baseUrl: string, contestId: ContestId, purpose: string) => {
    const params = new URLSearchParams({ contestId, purpose });
    const url = `${baseUrl}/finalize?${params}`;
    await fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });
  },
};
